import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const getCampaginListData = async () => {
  try {
    const response = await apiService.get("/get-campaign-page/1");
    return response.data
  } catch (error) {}
};
